import { useTracking } from '@change-corgi/core-react/tracking';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

type UseTaglineReturn = ModelHookResult<
	{
		totalUserCount: number;
		totalUserCountLocalized: string;
		learnMoreLinkHref: string;
	},
	{
		onLearnMoreClick: () => void;
	}
>;

export const useTagline = (): UseTaglineReturn => {
	const {
		data: { totalUserCount },
	} = useHomepagePageData();

	const track = useTracking();

	return {
		data: {
			totalUserCount: totalUserCount.total,
			totalUserCountLocalized: totalUserCount.totalLocalizedCompact,
			learnMoreLinkHref: '/start-a-petition/intro?source_location=homepage_secondary_button',
		},
		actions: {
			onLearnMoreClick: () => {
				void track('homepage_SAP_click', {
					cta: 'secondary',
				});
			},
		},
	};
};
